const Meta = Class(
  /**
   * @lends {Meta#}
   */
  {
    _url: '',
    _lang: '',
    _section: 'default',
    _prefix: 'web.og.',
    _rendered: [],
    _tags: new Map(),
    setUrl (url) {
      if (D.SITE_B2B) {
        this._prefix = 'b2b.web.og.';
      }
      url = url.replace(/^\/+|\/+$/g, '').split('?', 1)[0];
      let urlParts = url.split('/');
      this._lang = urlParts[0];
      urlParts.shift();
      this._section = urlParts[0] || 'default';
      this._url = urlParts.join('/');
      return this;
    },
    setSection (section) {
      this._url = section;
      this._section = section.replace('/', '.');
      return this;
    },
    set (selector, attributes, tagName = 'meta') {
      // console.log(selector, attributes, tagName);
      let selectorString = tagName;
      for (const [key, value] of Object.entries(selector)) {
        selectorString += `[${key}="${value}"]`;
      }
      this._tags.set(
        selectorString,
        {
          tagName: tagName,
          attributes: {
            ...selector,
            ...attributes
          }
        }
      );
      return this;
    },
    setTitle (content) {
      this._title = content;
      return this;
    },
    getTitle () {
      return this._title;
    },
    setDescription (content) {
      this._description = content;
      return this.set(
        {
          name: 'description',
        },
        {
          content: content
        },
      );
    },
    setOgTitle (content) {
      return this.set(
        {
          property: 'og:title',
        },
        {
          content: content
        },
      );
    },
    setOgDescription (content) {
      return this.set(
        {
          property: 'og:description',
        },
        {
          content: content
        },
      );
    },
    setOgImage (content) {
      return this.set(
        {
          property: 'og:image',
        },
        {
          content: content
        },
      );
    },
    setCanonical (href) {
      return this.set(
        {
          rel: 'canonical',
        },
        {
          href: D.url(href, this._lang, true)
        },
        'link'
      );
    },
    setAlternates (href, languages, defaultLanguage) {
      for (let i = 0; i < languages.length; i++) {
        const language = languages[i];
        this.set(
          {
            rel: 'alternate',
            hreflang: language
          },
          {
            href: D.url(href, language, true),
          },
          'link'
        );
      }
      this.set(
        {
          rel: 'alternate',
          hreflang: 'x-default'
        },
        {
          href: D.url(href, defaultLanguage || D.DEFAULT_LANG, true),
        },
        'link'
      );
      return this;
    },
    setAlternate (alternates) {
      for (const [key, value] of Object.entries(alternates)) {
        this.set(
          {
            rel: 'alternate',
            hreflang: key,
          },
          {
            href: value,
          },
          'link'
        );
      }
      return this;
    },
    setRobots (content) {
      this.set(
        {
          name: 'robots',
        },
        {
          content: content,
        },
        'meta'
      );
      return this;
    },
    render () {
      if (!this._title) {
        this.setTitle(
          D.Lang.get(
            `${this._prefix}${this._section}.title`,
            D.Lang.get(`${this._prefix}default.title`, 'Roadgames')
          )
        );
      }
      if (!this._tags.get('meta[name="description"]')) {
        this.setDescription(
          D.Lang.get(
            `${this._prefix}${this._section}.description`,
            D.Lang.get(`${this._prefix}default.description`)
          )
        );
      }
      if (!this._tags.get('meta[property="og:title"]')) {
        this.setOgTitle(
          D.Lang.get(
            `${this._prefix}${this._section}.ogTitle`,
            this._title
          )
        );
      }
      if (!this._tags.get('meta[property="og:description"]')) {
        this.setOgDescription(
          D.Lang.get(
            `${this._prefix}${this._section}.ogDescription`,
            this._description
          )
        );
      }
      if (!this._tags.get('meta[property="og:image"]')) {
        this.setOgImage(D.URL + 'assets/images/og-2024.png');
      }
      if (!this._tags.get('link[rel="canonical"]')) {
        this.setCanonical(this._url);
      }
      if (!this._tags.get('link[rel="alternate"][hreflang="x-default"]')) {
        this.setAlternates(this._url, D.LANGS);
      }

      document.title = this._title;
      this._tags.forEach((tag, selectorString) => {
        const newEl = mkE({
          tag: tag.tagName,
          attr: tag.attributes
        });
        const el = document.querySelector(selectorString);
        if (el) {
          newEl.replace(el);
        } else {
          newEl.append(document.head);
        }
        this._rendered.push(newEl);
      });

      this._tags.clear();
    },
    onLeave () {
      for (let i = 0; i < this._rendered.length; i++) {
        this._rendered[i]?.remove();
      }
    }
  }
);